import { useEffect, useState } from 'react';
import { Modal } from '@/components/ui/Modal/Modal';
import { Input } from '@/components/ui/Input/Input';
import { Button } from '@/components/ui/Button/Button';

export type FonotekaNameDialogProps = {
  open: boolean;
  title: string;
  label: string;
  initialName: string;
  confirmLabel: string;
  saving: boolean;
  error?: string | null;
  onClose: () => void;
  onConfirm: (name: string) => Promise<void>;
  onClearError?: () => void;
};

export function FonotekaNameDialog({
  open,
  title,
  label,
  initialName,
  confirmLabel,
  saving,
  error = null,
  onClose,
  onConfirm,
  onClearError,
}: FonotekaNameDialogProps) {
  const [value, setValue] = useState('');

  useEffect(() => {
    if (open) setValue(initialName);
  }, [open, initialName]);

  const handleClose = () => {
    if (!saving) onClose();
  };

  const submit = async () => {
    const name = value.trim();
    if (!name) return;
    await onConfirm(name);
  };

  return (
    <Modal open={open} onClose={handleClose} title={title} headerVariant="island" size="sm">
      <div className="flex flex-col gap-4 p-1">
        <Input
          label={label}
          value={value}
          error={error ?? undefined}
          onChange={(e) => {
            setValue(e.target.value);
            if (error) onClearError?.();
          }}
          disabled={saving}
          autoFocus
          onKeyDown={(e) => {
            if (e.key === 'Enter') void submit();
          }}
        />
        <div className="flex justify-end gap-2">
          <Button type="button" variant="outlined" size="m" disabled={saving} onClick={handleClose}>
            Отмена
          </Button>
          <Button type="button" variant="primary" size="m" disabled={saving || !value.trim()} onClick={() => void submit()}>
            {confirmLabel}
          </Button>
        </div>
      </div>
    </Modal>
  );
}
